<iq-central-front-end-navbar></iq-central-front-end-navbar>
<section class="container my-5">
  <div class="my-3 d-flex justify-content-between">
    <div class="font20">All Users</div>
    <div data-toggle="modal" data-target="#addStaffModal">
      <button class="btn btn-secondary btn-sm">Add Staff</button>
    </div>
  </div>
  <div class="d-flex align-items-center sm-reverse my-2 table-search-container">
    <div
      class="text-green font12 font-bold col-lg-2 col-md-2 col-sm-12 sm-text-center sm-mt sm-mb-2"
    >
      ADD FILTER
      <span class="dropdown click">
        <span
          class="font-bold text-green font12 dropdown-toggle"
          id="dropdownMenuButton"
          data-toggle="dropdown"
        >
        </span>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item click line-under" (click)="Admin()">Admin</a>
          <a class="dropdown-item click" (click)="sortByDesignation()"
            >Designation</a
          >
          <a class="dropdown-item click" (click)="sortByDivision()">Division</a>
          <a class="dropdown-item click" (click)="sortByUnit()">Unit</a>
        </div>
      </span>
    </div>
    <div class="table-search col-lg-7 col-md-7 col-sm-12">
      <input
        type="text"
        placeholder="Search for Staff"
        #query
        (keyup)="filter(query.value)"
      />
    </div>
    <div class="sort col-lg-3 col-md-3 col-sm-12 sm-mt sm-mb-2 sm-text-center">
      <span class="font-bold font14 text-grey mr-3">SORT BY</span>
      <span class="dropdown click">
        <span
          class="font-bold text-green font12 dropdown-toggle"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          >Name <i class="fa fa-chevron-down"></i
        ></span>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item click line-under" (click)="sortByName()"
            >Name</a
          >
          <a class="dropdown-item click" (click)="sortByDept()">Department</a>
          <a class="dropdown-item click" (click)="sortByDate()">Date</a>
        </div>
      </span>
    </div>
  </div>
  <div class="my-3 list-view__wrapper">
    <div class="table-responsive">
      <table class="table no-wrap" id="myTable">
        <tbody>
          <tr
            class="my-5"
            *ngFor="
              let staff of staffs
                | paginate
                  : {
                      id: 'listing_pagination',
                      itemsPerPage: paginationInfo.size,
                      currentPage: paginationInfo.number,
                      totalItems: paginationInfo.totalElements
                    }
            "
          >
            <td class="no-wrap float-left">
              <div
                class="float-left d-flex justify-content-around align-items-center"
              >
                <div class="img">
                  <img
                    src="{{
                      staff?.user?.avatarUrl
                        ? staff?.user?.avatarUrl
                        : 'assets/images/avatar.jpg'
                    }}"
                    alt=""
                    class="w-100 rounded-circle"
                    width="50"
                    height="50"
                  />
                </div>

                <div class="mx-3">
                  <p class="mt-0 staffUser mb-0 font14">
                    {{ staff?.user.fullName | titlecase }}
                  </p>
                  <p class="header mt-1 value mb-0">
                    {{ staff?.designation?.name }}
                  </p>
                </div>
              </div>
            </td>

            <td>
              <div
                class="mx-2 d-flex justify-content-around align-items-center float-left"
              >
                <div class="mx-2">
                  <p class="header mb-0">DEPARTMENT</p>
                  <p class="value mt-1 mb-0">
                    {{ staff?.department?.name }}
                  </p>
                </div>
              </div>
            </td>
            <td>
              <div
                class="mx-2 d-flex justify-content-around align-items-center float-left"
              >
                <div class="mx-2">
                  <p class="header mb-0">UNIT</p>
                  <p class="value mt-1 mb-0">{{ staff?.unit?.name }}</p>
                </div>
              </div>
            </td>
            <td>
              <div
                class="mx-2 d-flex justify-content-around align-items-center float-left"
              >
                <div class="mx-2">
                  <p class="header mb-0">STATUS</p>
                  <p
                    class="value mt-1 mb-0 px-2 staffStatusInactive staffStatus"
                    *ngIf="!staff?.active"
                  >
                    Deactivated
                  </p>
                  <p
                    class="value mt-1 mb-0 px-2 staffStatusActive staffStatus"
                    *ngIf="staff?.active"
                  >
                    Active
                  </p>
                </div>
              </div>
            </td>
            <td>
              <div
                class="mx-2 d-flex justify-content-around align-items-center float-left"
              >
                <div class="mx-2">
                  <p class="header mb-0">DATE ADDED</p>
                  <p class="value mt-1 mb-0">{{ staff?.createdAt | date }}</p>
                </div>
              </div>
            </td>
            <td>
              <button
                class="btn btn-secondary btn-sm mr-1"
                [routerLink]="[
                  '/staff/staff-details',
                  staff.id,
                  { edit: true }
                ]"
              >
                Edit
              </button>
              <button
                class="btn btn-outline-secondary btn-sm ml-1"
                [routerLink]="['/staff/staff-details', staff.id]"
              >
                View
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-center sm-flex-column">
      <pagination-controls
        id="listing_pagination"
        (pageChange)="navigatePage($event)"
      ></pagination-controls>
    </div>
  </div>
  <div class="mt-auto">
    <hr />
    <iq-central-front-end-footer></iq-central-front-end-footer>
  </div>
</section>

<!--Add Staff Modal -->
<div
  class="modal fade"
  id="addStaffModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="addStaffModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-md text-black" role="document ">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title mt-3" id="editModalLabel">New Staff</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true" id="staffX">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="staffForm">
          <div class="row pt-5 px-3">
            <div class="col-lg-12 col-sm-12">
              <div class="form-row">
                <div class="col-12 form-group d-flex text-black">
                  <input
                    type="text"
                    class="text-black my-1 inpField bg-white w-100 form-control text-greyed"
                    placeholder="Full Name"
                    formControlName="fullName"
                    [ngClass]="{
                      'is-invalid':
                        staffForm.get('fullName').errors &&
                        staffForm.get('fullName').touched
                    }"
                  />

                  <span class="text-danger">*</span>
                </div>
              </div>

              <div class="form-row">
                <div class="col-lg-6 col-sm-12 form-group d-flex">
                  <select
                    type="text"
                    [ngClass]="{
                      'is-invalid':
                        staffForm.get('designationId').errors &&
                        staffForm.get('designationId').touched
                    }"
                    class="staff-input text-greyed my-1 bg-white w-100 form-control"
                    formControlName="designationId"
                  >
                    <option value="" selected class="text-greyed">
                      Designation
                    </option>
                    <option
                      value="{{ designation?.id }}"
                      *ngFor="let designation of designations"
                    >
                      {{ designation?.name }}
                    </option>
                  </select>
                  <span class="text-danger">*</span>
                </div>
                <div class="col-lg-6 col-sm-12 form-group d-flex">
                  <input
                    type="text"
                    [ngClass]="{
                      'is-invalid':
                        staffForm.get('employmentNumber').errors &&
                        staffForm.get('employmentNumber').touched
                    }"
                    class="inpField my-1 bg-white w-100 form-control text-greyed"
                    placeholder="Employment No"
                    formControlName="employmentNumber"
                  />
                  <span class="text-danger">*</span>
                </div>
              </div>
              <div class="form-row">
                <div class="col-12 form-group d-flex">
                  <input
                    type="email"
                    [ngClass]="{
                      'is-invalid':
                        staffForm.get('username').errors &&
                        staffForm.get('username').touched
                    }"
                    class="inpField my-1 bg-white w-100 form-control text-greyed"
                    placeholder="Email Address"
                    formControlName="username"
                  />
                  <span class="text-danger">*</span>
                </div>
              </div>

              <div class="form-row">
                <div class="col-lg-6 col-sm-12 form-group d-flex">
                  <select
                    type="text"
                    (change)="getAllDivisionsByDepartment($event.target.value)"
                    [ngClass]="{
                      'is-invalid':
                        staffForm.get('departmentId').errors &&
                        staffForm.get('departmentId').touched
                    }"
                    class="staff-input text-greyed my-1 bg-white w-100 form-control"
                    formControlName="departmentId"
                  >
                    <option value="" selected class="text-greyed">
                      Department
                    </option>
                    <option
                      value="{{ department?.id }}"
                      *ngFor="let department of departments"
                    >
                      {{ department?.name }}
                    </option>
                  </select>
                  <span class="text-danger">*</span>
                </div>
                <div class="col-lg-6 col-sm-12 form-group d-flex">
                  <select
                    type="text"
                    (change)="getAllUnitsByDivision($event.target.value)"
                    [ngClass]="{
                      'is-invalid':
                        staffForm.get('divisionId').errors &&
                        staffForm.get('divisionId').touched
                    }"
                    class="staff-input text-greyed my-1 bg-white w-100 form-control"
                    formControlName="divisionId"
                  >
                    <option value="" class="text-greyed">Division</option>
                    <option
                      value="{{ division?.id }}"
                      *ngFor="let division of divisions"
                    >
                      {{ division?.name }}
                    </option>
                  </select>
                  <span class="text-danger">*</span>
                </div>
              </div>
              <div class="form-row">
                <div class="col-lg-6 col-sm-12 form-group d-flex">
                  <select
                    type="text"
                    [ngClass]="{
                      'is-invalid':
                        staffForm.get('unitId').errors &&
                        staffForm.get('unitId').touched
                    }"
                    class="staff-input my-1 text-greyed bg-white w-100 form-control"
                    formControlName="unitId"
                  >
                    <option value="" selected disabled class="text-greyed">
                      Unit
                    </option>
                    <option value="{{ unit?.id }}" *ngFor="let unit of units">
                      {{ unit?.name }}
                    </option>
                  </select>
                  <span class="text-danger">*</span>
                </div>
                <div class="col-lg-6 col-sm-12">
                  <select
                    type="text"
                    formControlName="isAdmin"
                    class="common-input my-1 bg-white w-100"
                  >
                    <option value="" selected disabled>Admin?</option>
                    <option [value]="false">No</option>
                    <option [value]="true">Yes</option>
                  </select>
                </div>
              </div>

              <div class="mt-2 mb-5 text-center form-group">
                <button
                  type="button"
                  (click)="onSubmit()"
                  class="btn btn-secondary"
                >
                  <div class="staffBtn m-2">Add Staff</div>
                </button>

                <button data-dismiss="modal" #dismiss hidden></button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
